import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { IForm } from 'core-components/classes/models/IForm'
import { ITableProps } from 'core-components/library/list/types'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

import { checkRoles } from '../helpers/checkRoles'

interface IUseRowActions {
  rowActions: ITableProps<IForm>['rowActions']
  editRoles: string[]
  deleteRoles: string[]
  setEditItem: (item: IForm) => void
  setRemoveItem: (item: IForm) => void
}

export const useRowActions = ({
  rowActions = [],
  editRoles = [],
  deleteRoles = [],
  setEditItem,
  setRemoveItem,
}: IUseRowActions) => {
  const user = useSelector(selectUser)
  const canEdit = useMemo(() => {
    return checkRoles(user.roleIds, editRoles)
  }, [editRoles, user?.roleIds])

  const canDelete = useMemo(() => {
    return checkRoles(user.roleIds, deleteRoles)
  }, [deleteRoles, user?.roleIds])

  const editRowAction = useMemo(() => {
    return {
      id: 'edit',
      title: 'Edit',
      icon: 'kbase kbase-edit',
      action: (item: IForm) => {
        return setEditItem({ ...item })
      },
    }
  }, [setEditItem])

  const deleteRowAction = useMemo(() => {
    return {
      id: 'edit',
      title: 'Edit',
      icon: 'kbase kbase-delete',
      action: (item: IForm) => {
        return setRemoveItem({ ...item })
      },
    }
  }, [setRemoveItem])

  const tableRowActions = useMemo(() => {
    const newRowActions = [...rowActions]
    if (canEdit) {
      newRowActions.push(editRowAction)
    }
    if (canDelete) {
      newRowActions.push(deleteRowAction)
    }
    return newRowActions
  }, [canDelete, canEdit, deleteRowAction, editRowAction, rowActions])

  return { rowActions: tableRowActions, canEdit, canDelete }
}
